import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Down: FC<IconSvgProps> = ({ color, clss }) => {
    const styles = {
        svg: {
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
    };

    return (
        <svg style={{ ...styles.svg, transform: 'rotate(180deg)' }} className={clss} width="17" height="22" viewBox="2 -3 17 22">
            <g fill="none" fillRule="evenodd">
                <g fill={color}>
                    <g>
                        <path d="M10.086-1.825l-6.8 5.6c-.345.299-.375.808-.107 1.132.269.324.808.374 1.132.106L9.798.5v16.7c0 .442.359.8.8.8.442 0 .8-.358.8-.8V.5l5.488 4.513c.324.268.859.214 1.131-.106.287-.339.218-.863-.106-1.131l-6.8-5.6c-.389-.25-.682-.218-1.025 0" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Down;
